<i18n>
{
  "en": {
    "title": "MLB 9 Innings configuration page",
    "onlySupportIDLogin": "XRobotmon only support login MLB 9 Innings via Hive ID/Email",
    "first_time": "First time? Please refer:",
    "mlb9i_tutorial": "MLB 9 Innings tutorial",
    "mlb9i_tutorial_link": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/en/xrobotmon-tutorial",
    "logoutGameAccount_btn": "Logout game account",
    "logoutGameAccount_desc": "If you want to switch to another game account, you can click the button below to logout. The manual login process will be initiated the next time you start XRobotmon.",
    "logoutGameAccount_alert": "Logout game account completed"
  },
  "zhHant": {
    "title": "MLB 9 Innings 設定頁面",
    "onlySupportIDLogin": "XRobotmon只支持透過Hive ID/Email登入MLB 9 Innings",
    "first_time": "第一次使用嗎？請參考：",
    "mlb9i_tutorial": "MLB 9局職棒簡易使用教學",
    "mlb9i_tutorial_link": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/zh/xrobotmon-tutorial",
    "logoutGameAccount_btn": "登出遊戲帳號",
    "logoutGameAccount_desc": "若您想換其他遊戲帳號，可以點擊以下按鈕登出，下次啟動XRobotmon時就會進行手動登入程序",
    "logoutGameAccount_alert": "遊戲帳號登出完成"
  },
  "ja": {
    "title": "MLB 9 Innings 設定ページ",
    "onlySupportIDLogin": "XRobotmonはHive ID/EmailでのみMLB 9 Inningsにログインをサポートしています",
    "first_time": "詳細な使い方はこちらからどうぞ：",
    "mlb9i_tutorial": "MLB 9 Innings使い方",
    "mlb9i_tutorial_link": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/ja/xrobotmon-tutorial",
    "logoutGameAccount_btn": "ゲームアカウントをログアウトする",
    "logoutGameAccount_desc": "他のゲームアカウントに切り替えたい場合は、以下のボタンをクリックしてログアウトしてください。次にXRobotmonを起動するときに手動ログインプロセスが開始されます。",
    "logoutGameAccount_alert": "ゲームアカウントのログアウトが完了しました"
  },
  "ko": {
    "title": "MLB 9 Innings 설정 페이지",
    "onlySupportIDLogin": "XRobotmon은 Hive ID/Email을 통해서만 MLB 9 Innings에 로그인을 지원합니다",
    "first_time": "처음 이용하신다면 여기를 눌러 참고하세요",
    "mlb9i_tutorial": "MLB 9 Innings 설정을 가르쳐드립니다.",
    "mlb9i_tutorial_link": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/en/xrobotmon-tutorial",
    "logoutGameAccount_btn": "게임 계정 로그아웃",
    "logoutGameAccount_desc": "다른 게임 계정으로 전환하려면 아래 버튼을 클릭하여 로그아웃하십시오. 다음에 XRobotmon을 시작할 때 수동 로그인 프로세스가 시작됩니다.",
    "logoutGameAccount_alert": "게임 계정 로그아웃이 완료되었습니다"
  }
}
</i18n>

<template>
  <div>
    <div v-show="!license">OOPS! This license cannot be found!</div>
    <v-card flat v-show="license">
      <v-card-title class="headline">{{ $t('title') }}</v-card-title>
      <v-card-text>
        <v-alert :value="true" type="warning" outline>
          {{ $t('onlySupportIDLogin') }}
          <v-divider class="my-2 warning" style="opacity: 0.22"></v-divider>
          {{ $t('first_time') }}
          <a :href="$t('mlb9i_tutorial_link')" target="_blank" class="warning--text font-weight-medium">{{
            $t('mlb9i_tutorial')
          }}</a>
        </v-alert>
        <v-alert :value="license.type !== 'trial'" color="info" outline>
          {{ $t('logoutGameAccount_desc') }}
          <v-btn
            v-if="license.taskConfig !== null"
            text-color="white"
            small
            block
            @click="logoutGameAccount(license)"
            :loading="isGameAccountSigningOut"
            :disabled="isGameAccountSigningOut"
          >
            {{ $t('logoutGameAccount_btn') }}
          </v-btn>
        </v-alert>
      </v-card-text>
      <Config
        :localTaskConfig="localTaskConfig"
        :licenseType="license.type"
        :isLoading="isLoading"
        :advancedConfigBtn="false"
        @onSave="onSave"
      />
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { getMLB9ICurrentConfig } from './game-configs/mlb9i';
import Config from './Config';

export default {
  name: 'configMlb9i',
  components: {
    Config,
  },
  props: {
    license: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isGameAccountSigningOut: false,
      localTaskConfig: {},
    };
  },
  created() {
    if (!this.license) {
      this.$router.push({ name: 'home' });
      return;
    }
    this.$set(this, 'localTaskConfig', getMLB9ICurrentConfig(this.license.taskConfig));
  },
  methods: {
    async onSave(configToPost) {
      this.isLoading = true;
      await firebase.functions().httpsCallable('xPostTaskConfigs')({
        licenseId: this.license.licenseId,
        task: this.license.task || 'mlb9i',
        taskConfig: configToPost,
      });
      this.isLoading = false;
      this.$router.push({ name: 'home' });
    },
    async logoutGameAccount() {
      this.isGameAccountSigningOut = true;
      try {
        const success = await firebase.functions().httpsCallable('XRobotmonGroup-xDeleteLoginCache')({
          licenseId: this.license.licenseId,
        });
        console.log(`logoutGameAccount`, success);
      } catch (e) {
        console.log(`logoutGameAccount`, e.message);
      } finally {
        this.isGameAccountSigningOut = false;
        alert(this.$t('logoutGameAccount_alert'));
      }
    },
  },
};
</script>
